import * as S from 'components/DownloadResourcesPage/styles';
import Layout from 'components/Layout';
import React from 'react';

import { SEO } from '../components/SEO';

export const Head = () => <SEO />;

export const downloadResourcesPage3 = () => (
  <Layout>
    <S.SectionWrapper>
      <S.Container>
        <S.Row>
          <S.Headline>Sign Up to Receive Content</S.Headline>
        </S.Row>

        <S.IFrame
          title="Download the white paper"
          src="https://go.everlywell.com/l/882283/2023-11-13/58ns1?Requested_Content=EWP_Case_Study"
          width="100%"
          height="auto"
        ></S.IFrame>
      </S.Container>
    </S.SectionWrapper>
  </Layout>
);

export default downloadResourcesPage3;
